import React from 'react'
import { Card } from '@softwaredev_cegeka/stix-core/dist/components'
import { DataTable } from '@softwaredev_cegeka/stix-data-table/dist/components'
import { Link } from 'react-router-dom'

import { authenticatedUserStore } from 'src/stores'
import { AuthApi } from 'src/api/authApi'
import { formatDate } from 'src/utils/utils'

import './homePageWidgets.scss'
import { observer } from 'mobx-react'

class LastLoggedInUsersTable extends React.Component {
    state = {
        users: [...Array(5)].map(item => ({})),
        loading: false,
    }
    authClient = new AuthApi(authenticatedUserStore.authToken)

    componentDidMount() {
        this.fetchAndStoreUsers()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            prevProps.selectedOrganization !== this.props.selectedOrganization
        ) {
            this.fetchAndStoreUsers()
        }
    }

    componentWillUnmount() {
        this.authClient.cancelRequest()
    }

    fetchAndStoreUsers = () => {
        this.setState({ loading: true })
        this.authClient
            .fetchUsers(
                1,
                this.props.history,
                {
                    per_page: 5,
                    load_relationships: false,
                    sort: '-last_login_datetime',
                },
                authenticatedUserStore.selectedOrganization?.id
            )
            .then(response => {
                this.setState({
                    users: response?.data?.results,
                    loading: false,
                })
            })
    }

    render() {
        const columns = [
            {
                Header: 'First name',
                accessor: 'first_name',
            },
            {
                Header: 'Last name',
                accessor: 'last_name',
            },
            {
                Header: 'Last logged in',
                accessor: 'last_login_datetime',
                Cell: cell => {
                    return cell.value ? formatDate(cell.value) : ''
                },
            },
        ]
        return (
            <Card className={'last-logged-in-users'}>
                <Card.Header>Last logged in users</Card.Header>

                <DataTable
                    variant={'compact'}
                    loading={this.state.loading}
                    data={this.state.users}
                    columns={columns}
                    onSingleRowSelect={selectedRowObj => {
                        this.props.history.push(
                            '/user-form/' +
                                selectedRowObj.selectedRow.original.username
                        )
                    }}
                />

                <Card.Footer>
                    <Link to={'/users'}>View all users</Link>
                </Card.Footer>
            </Card>
        )
    }
}

export default observer(LastLoggedInUsersTable)
